import { lazy, Suspense, useEffect, useState } from "react";

const Toaster = lazy(() =>
  import("./sonner").then((m) => ({ default: m.Toaster })),
);

/**
 * Mounts the Sonner toaster only after the page is interactive (idle),
 * so its JS does not contribute to TBT on first load.
 */
export function DeferredToaster() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const w = window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };
    const trigger = () => setReady(true);
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(trigger, { timeout: 2000 });
    } else {
      const t = window.setTimeout(trigger, 1500);
      return () => window.clearTimeout(t);
    }
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <Toaster theme="dark" position="top-center" />
    </Suspense>
  );
}
